import styled, {css} from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.div`
${({ theme, displayState }) => css`
  visibility: ${displayState?.hidden ? 'hidden' : 'visibile'};
  margin-right: 5px;
  margin-left: 5px;
  cursor: pointer;
`}
`


export default Atom({ type: 'button', dataType: '', template });
